import React, { useState, useEffect } from 'react';
import './embalaje.css';

function Embalaje() {
  const [pasoActual, setPasoActual] = useState(0);

  const pasos = [
    {
      id: 1,
      imagen: "/paso1.jpg",
      titulo: "Preparación de materiales",
      descripcion: "Reúne todos los materiales necesarios: cajas de cartón resistentes, cinta adhesiva, material de relleno (burbujas, papel), marcadores y tijeras."
    },
    {
      id: 2, 
      imagen: "/embalaje.jpg",
      titulo: "Protección del contenido",
      descripcion: "Envuelve cada artículo individualmente con papel burbuja o papel de embalaje. Presta especial atención a los objetos frágiles y asegúrate de proteger bien las esquinas y bordes."
    },
    {
      id: 3,
      imagen: "/paso3.jpg",
      titulo: "Sellado y etiquetado",
      descripcion: "Coloca los objetos en la caja, rellenando los espacios vacíos con material de relleno. Sella la caja con cinta adhesiva en forma de H y etiqueta claramente el contenido y la orientación."
    },
    {
      id: 4,
      imagen: "/paso4.png",
      titulo: "Organización por categorías",
      descripcion: "Agrupa los artículos por categorías (ropa, libros, electrónicos) y embala cada grupo por separado. Esto facilitará la organización y el desembalaje posterior."
    },
    {
      id: 5,
      imagen: "/paso5.png",
      titulo: "Protección de muebles",
      descripcion: "Desmonta los muebles que sea posible y protege las superficies con mantas o plástico burbuja. Asegura las partes móviles y guarda los tornillos en bolsas etiquetadas."
    },
    {
      id: 6,
      imagen: "/paso6.png",
      titulo: "Inventario final",
      descripcion: "Crea una lista detallada de todas las cajas y su contenido. Toma fotos de los artículos valiosos antes de embalarlos y guarda la documentación en un lugar seguro."
    }
  ];

  useEffect(() => {
    const intervalo = setInterval(() => {
      setPasoActual((prevPaso) => (prevPaso + 1) % pasos.length);
    }, 5000); // Cambia cada 5 segundos

    return () => clearInterval(intervalo);
  }, []);

  const siguientePaso = () => {
    setPasoActual((prevPaso) => (prevPaso + 1) % pasos.length);
  };

  const pasoAnterior = () => {
    setPasoActual((prevPaso) => (prevPaso - 1 + pasos.length) % pasos.length);
  };

  return (
    <div className="embalaje-container">
      <div className="embalaje-header">
        <h1 className="embalaje-titulo">EMBALAJE</h1>
        <p className="embalaje-subtitulo">
          Aprende a embalar tus pertenencias de manera segura y profesional con nuestra guía paso a paso. 
          Siguiendo estas instrucciones, garantizarás que tus artículos lleguen a su destino en perfectas condiciones.
        </p>
      </div>

      <div className="carousel-container">
        <button className="carousel-button prev" onClick={pasoAnterior}>
          &#10094;
        </button>
        
        <div className="paso-item">
          <div className="paso-imagen">
            <img src={pasos[pasoActual].imagen} alt={`Paso ${pasos[pasoActual].id}`} />
          </div>
          <div className="paso-contenido">
            <h2>Paso {pasos[pasoActual].id}: {pasos[pasoActual].titulo}</h2>
            <p>{pasos[pasoActual].descripcion}</p>
          </div>
        </div>

        <button className="carousel-button next" onClick={siguientePaso}>
          &#10095;
        </button>
      </div>

      <div className="carousel-indicators">
        {pasos.map((_, index) => (
          <span
            key={index}
            className={`indicator ${index === pasoActual ? 'active' : ''}`}
            onClick={() => setPasoActual(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default Embalaje;
